module.exports = __webpack_public_path__ + "img/clases.2d68bcf2.svg";